import React, { Component } from 'react';
import PodcastSeriesItem from './PodcastSeriesItem';
import ThemePageBanner from "../../../../../../dashboardNew/components/ThemePageBanner";

class PodcastSeriesList extends Component {
    render() {
        const seriesList = this.props.series;
       
        return (
            <div className="container">
                <div className="row">
                    { Object.keys( seriesList ).map( ( series, index ) => {
                        return (
                            <PodcastSeriesItem key={ index } index={ index } series={ seriesList[ series ] }  />
                        );
                    } ) }
                </div>
            </div>
        );
    };
}

export default PodcastSeriesList;



// WEBPACK FOOTER //
// src/client/components/site/features/training/podcasts/series/elements/PodcastSeriesList.js